import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import designationService from "../../services/DesignationService";


export const getDesignationList = createAsyncThunk(
    "designation/getDesignationList",
    async (_,{ rejectWithValue }) => {
        try {
            const response = await designationService.GetDesignationList();
            return response.data?.ResultSet || [];
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message || 
                error.message || 
                "Failed to get designation list"
            );
        }
    }
)

export const addDesignation = createAsyncThunk(
    "designation/addDesignation",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await designationService.AddDesignation(payload);
            return response.data?.ResultSet || [];
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message || 
                error.message || 
                "Failed to add designation"
            );
        }
    }
)

export const updateDesignation = createAsyncThunk(
    "designation/updateDesignation",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await designationService.UpdateDesignation(payload);
            return response.data?.ResultSet || [];
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message || 
                error.message || 
                "Failed to update designation"
            );
        }
    }
)

const initialState = {
  designations: [],

  loading: false,

  saving: false,

  error: null,
  success: false,
};

const designationSlice = createSlice({
    name: "designation",
    initialState,
    reducers: {
        clearDesignationError: (state) => {
            state.error = null;
        },

        clearDesignationSuccess: (state) => {
            state.success = false;
        },

        clearDesignations: (state) => {
            state.designations = [];
        }
    },

    extraReducers: (builder) => {
        builder

        // Get designation list
        .addCase(
            getDesignationList.pending,
            (state) => {
                state.loading = true;
                state.error = null;
            }
        )
        .addCase(
            getDesignationList.fulfilled,
            (state, action) => {
                state.loading = false;
                state.designations = action.payload;
            }
        )
        .addCase(
            getDesignationList.rejected,
            (state, action) => {
                state.loading = false;
                state.error = action.payload || "Failed to load designations";
            }
        )

        // Add Designation
        .addCase(addDesignation.pending, (state) => {
            state.saving = true;
            state.error = null;
            state.success = false;
        })
        .addCase(addDesignation.fulfilled, (state) => {
            state.saving = false;
            state.success = true;
        })
        .addCase(addDesignation.rejected, (state, action) => {
            state.saving = false;
            state.error = action.payload || "Failed to add designation"
        })

        // Update Designation
        .addCase(updateDesignation.pending, (state) => {
            state.saving = true;
            state.error = null;
            state.success = false;
        })
        .addCase(updateDesignation.fulfilled, (state) => {
            state.saving = false;
            state.success = true;
        })
        .addCase(updateDesignation.rejected, (state, action) => {
            state.saving = false;
            state.error = action.payload || "Failed to update designation"
        })
    }
})

export const {
    clearDesignationError,
    clearDesignationSuccess,
    clearDesignations
} = designationSlice.actions;

export default designationSlice.reducer;